import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

import { RootState } from "../../../../globals";

export interface PlantelElegido { id: number; countryId: number; nombre: string }

/**
 * Antes de una Solicitud o una Matrícula nueva se confirma el plantel (Esteban, 2026-10-12: "que nada caiga en el plantel
 * equivocado"). Viene marcado el de la barra (o el sugerido), pero hay que tocar "Continuar" a propósito.
 */
const ConfirmarPlantel: React.FC<{ que: string; sugerido: number | null; onElegir: (p: PlantelElegido) => void; onCerrar: () => void }> = ({ que, sugerido, onElegir, onCerrar }) => {
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const planteles: { id: number; countryId: number; nombre: string }[] = (Object.values(campusRef || {}) as any[])
		.filter((c) => c && c.id)
		.map((c) => ({ id: Number(c.id), countryId: Number(c.company?.country_id || 0), nombre: String(c.name || "Plantel " + c.id) }));
	const [sel, setSel] = useState<number | null>(planteles.some((p) => p.id === sugerido) ? sugerido : planteles.length === 1 ? planteles[0].id : null);
	const elegido = planteles.find((p) => p.id === sel) || null;
	return (
		<Modal show onHide={onCerrar} centered fullscreen="sm-down" className="waModulo">
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: 18 }}>¿En Qué Plantel?</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ textAlign: "left" }}>
				<p style={{ margin: "0 0 10px", color: "var(--wa-apagado)", fontSize: 14 }}>Confirma el plantel de la {que} nueva.</p>
				<div role="radiogroup" aria-label="Plantel" style={{ display: "flex", flexDirection: "column", gap: 6 }}>
					{planteles.map((p) => (
						<label key={p.id} style={{ position: "static", display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", margin: 0, cursor: "pointer", borderRadius: 8, fontSize: 15,
							border: "1.5px solid " + (sel === p.id ? "var(--wa-acento)" : "var(--wa-filo)"), background: sel === p.id ? "var(--wa-acento-suave)" : "var(--wa-superficie)", fontWeight: sel === p.id ? 700 : 400 }}>
							<input type="radio" name="confirmarPlantel" checked={sel === p.id} onChange={() => setSel(p.id)} style={{ accentColor: "var(--wa-acento)" }} />
							{p.nombre}
						</label>
					))}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button type="button" className="btn btn-outline-secondary" onClick={onCerrar}>Cancelar</button>
				<button type="button" className="btn btn-primary" disabled={!elegido} onClick={() => elegido && onElegir(elegido)}>
					{elegido ? "Continuar en " + elegido.nombre : "Elige un plantel"}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmarPlantel;
